<template>
	<div class="content">
		<div class="content_head">
			<select v-model="areaID" v-if="$store.state.user.UserType==0" @change="selectArea">
				<option v-for="(i,index) in $store.state.area" :value="i.areaID">{{i.areaName}}</option>
			</select>

			<select v-model="ShopID" title="选择店铺" @change="pageIndex=1; getData()"
				v-if="$store.state.user.UserType<=1 && $store.state.user.ShopType<=1">
				<option v-for="i in Shop" :value="i.ShopID">
					{{i.ShopName}}
				</option>
			</select>


			<select v-model="searchText" @change="pageIndex=1;getData()">
				<option value="-1">全部收入</option>
				<option value="1">会员办理</option>
				<option value="2">会员退费</option>
				<option value="3">押金缴费</option>
				<option value="4">押金退费</option>
				<option value="5">阅读费用</option>
				<option value="6">配送费用</option>
				<option value="7">异常还书</option>
				<option value="8">书籍售出</option>
				<option value="9">书箱收费</option>
				<option value="10">书箱退费</option>
				<option value="11">体验课收费</option>
				<option value="12">体验课退费</option>
			</select>
			&nbsp;&nbsp;
			<input type="text" style="width: 15rem;" v-model="beginData" class="search"
				placeholder="开始时间(格式:2021-01-01)" />
			~
			<input type="text" style="width:15rem;" v-model="endTime" class="search"
				placeholder="结束时间(格式:2021-01-01)" />
			<button type="button" class="button " @click="pageIndex=1; getData()">查找</button>
		</div>
		<div class="content_body">
			<table>
				<thead>
					<tr>
						<th>序号</th>
						<th>客户姓名</th>
						<th>手机号</th>
						<th>应付金额</th>
						<th>实付金额</th>
						<th>付款时间</th>
						<th>付款说明</th>
						<th>类别</th>
						<th>操作人</th>
					</tr>
				</thead>
				<tbody>

					<tr v-for="(i,index) in payRecord">
						<td class="center">
							{{index+1+ (pageIndex-1)*pageRows}}
						</td>
						<td>{{i.CustomerName}}</td>
						<td>{{i.CustomerPhone}}</td>
						<td>{{i.PayMoney| rmb}} </td>
						<td class="red">{{i.Disbursements| rmb}}</td>
						<td>{{i.PayDate}}</td>
						<td style="width: 10rem;word-wrap: break-word">{{i.Remarks.length }}</td>
						<td>{{action[i.PayType -1]}}</td>
						<td>{{i.UserName}}</td>
					</tr>

				</tbody>
			</table>
		</div>
		<div class="foot_pages">
			应付合计:
			<span class="red">{{ sum.PayMoney | rmb}}</span>
			实付合计:
			<span class="red">{{ sum.Disbursements | rmb}}</span>
			<button class="button" :class="{'disabled':up}" :disabled="up" @click="changePages('up')">上一页</button>
			<span>{{page}}</span>

			<select v-model="pageRows" @change="changePageRows">
				<option value="5">5/页</option>
				<option value="10">10/页</option>
				<option value="15">15/页</option>

			</select>
			<button class="button" :class="{'disabled':down}" :disabled="down" @click="changePages('down')">下一页</button>
			押金总额:<span class="red">{{Deposit|rmb}}</span>
		</div>

	</div>

</template>

<script>
	import j from './queryMoney.js'
	export default j
</script>

<style>

</style>
